const delay = async (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms))
}

const isTouchDevice = () => {
    return !!('ontouchstart' in window);
}

const isIOS = () => {
    const ua = navigator.userAgent;

    if (['iPhone', 'iPad', 'iPod'].includes(navigator.platform)) {
        return true
    }

    if (isTouchDevice() && navigator.maxTouchPoints > 1 && /Safari/.test(ua)) {
        return true;
    }

    return /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
}

export {
    delay,
    isTouchDevice,
    isIOS
}
